// AuthProvider.js
import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { authConfig } from '../../config/config';

const AuthProvider = ({ children }) => {
    return (
        <Auth0Provider
            domain={authConfig.domain}
            clientId={authConfig.clientId}
            authorizationParams={{
                redirect_uri: window.location.origin,
            }}
        >
            {children}
        </Auth0Provider>
    );
};

export { AuthProvider };
